module.exports = __webpack_public_path__ + "img/system20.8f17f328.png";